export default __webpack_public_path__ + "static/media/avg-revenue-per-trip.4e38bb3d.png";